import * as ActionTypes from 'constants/actionTypes'
import { apiClient } from 'lib';

import store from 'store'

export const fetch = async(params = {})=>{
  let response
  
  response = await apiClient.organizations.genders.fetch({
    organizationID: store.getState().currentOrganization.id
  })

  const data = response.data.reduce((acc, item)=>{
    acc[item.id] = item
    return acc;
  }, {})

  store.dispatch({ 
    type: ActionTypes.FETCH_GENDERS,
    payload: data
  })
}

export const update = async(params = {}) => {
   const response = await apiClient.organizations.genders.update(params)

  store.dispatch({
    type: ActionTypes.UPDATE_GENDER,
    payload: response.data
  })
  
  return response.data
}

export const activate = async(ids = []) => {
  const response = await apiClient.organizations.genders.activate({ids})

  store.dispatch({
    type: ActionTypes.UPDATE_GENDERS,
    payload: response.data
  })

  return response.data
}

export const destroy = async(id) => {
  await apiClient.organizations.genders.destroy(id)

  store.dispatch({
    type: ActionTypes.DESTROY_GENDER,
    payload: id
  })
}

export const create = async(params = {}) => {
  const response = await apiClient.organizations.genders.create(params)

  store.dispatch({
    type: ActionTypes.CREATE_GENDER,
    payload: response.data
  })

  return response.data
}